const styles = Object.freeze({
    minPageWidth: 1000,
    minPageHeight: 720,
    topNavHeight: 58,
    sidebarWidth: 350,
    smallerSidebarWidth: 280
})

export default styles
